import type { OrderFilter, Query, QueryOrdersV2Args } from '@ab-core/graphql/dist';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { ORDERS } from './gql/orders';

type QueryDataType = Pick<Query, 'ordersV2'>;
type OutgoingDataType = QueryDataType['ordersV2'] | undefined;
type IncomingDataType = { filter?: OrderFilter; query?: string; page?: number };

const onError = getErrorLoggerFunction('orders');

export const useOrders = (props: IncomingDataType) => {
    const { filter, query = '*', page = 1 } = props;
    const [outgoingData, setOutgoingData] = useState<OutgoingDataType>(undefined);

    const { loading, data, error, refetch } = useQuery<QueryDataType, QueryOrdersV2Args>(ORDERS, {
        variables: {
            query,
            filter,
            page
        },
        skip: !filter,
        onError
    });

    useEffect(() => {
        if (data) {
            setOutgoingData(data.ordersV2);
        }
    }, [data]);

    return {
        orders: outgoingData,
        error: !!error,
        success: !!data,
        loading,
        refetch
    };
};
